
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastProvider } from './Toast';
import { ThemeProvider } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>  
    <ToastProvider>
      <App />
    </ToastProvider>
  </ThemeProvider>
);